<ng-container
  *ngIf="{
    data: data$ | async,
    numCases: numCases$ | async,
    numMembers: numMembers$ | async,
    caseTypeName: caseTypeName$ | async
  } as state"
>
  <div class="card">
    <div class="card-header text-center flex-column align-items-center" *ngIf="!state.mobile">
      <h2>
        {{ state.data?.name | uppercase }}
      </h2>
    </div>
    <nav mat-tab-nav-bar [tabPanel]="tabPanel" class="full-width space-evenly">
      <a
        mat-tab-link
        [routerLink]="['cases']"
        class="flex-column"
        routerLinkActive
        #rlCases="routerLinkActive"
        [active]="rlCases.isActive"
      >
        <div class="flex-row align-items-center" *ngIf="!state.mobile">
          <i class="ri-file-copy-2-line"></i>
          {{ state.numCases }} {{ 'core.cases' | translate }}
        </div>
        <div>
          <a class="button text-primary">
            <i class="ri-file-copy-2-line" *ngIf="!state.mobile"></i>
            {{ (state.mobile ? 'core.cases' : 'button.view_cases') | translate }}
          </a>
        </div>
      </a>
      <ng-container *ngIfRole="['admin']">
        <a
          mat-tab-link
          [routerLink]="['edit']"
          class="flex-column"
          routerLinkActive
          #rlEdit="routerLinkActive"
          [active]="rlEdit.isActive"
        >
          <div class="flex-row align-items-center" *ngIf="!state.mobile">
            <i class="ri-briefcase-4-line"></i>
            {{ 'core.case_type' | translate }}:
            {{ state.caseTypeName }}
          </div>
          <div>
            <a class="button text-primary">
              <i class="ri-pencil-line" *ngIf="!state.mobile"></i>
              {{ (state.mobile ? 'button.edit' : 'title.edit_workspace') | translate }}
            </a>
          </div>
        </a>
      </ng-container>
      <!-- Viewing workspace members is allowed for every role; add/remove actions
           inside the members view remain gated to managers/admin. -->
      <a
        mat-tab-link
        [routerLink]="['members']"
        class="flex-column"
        routerLinkActive
        #rlMembers="routerLinkActive"
        [active]="rlMembers.isActive"
      >
        <div class="flex-row align-items-center" *ngIf="!state.mobile">
          <i class="ri-group-line"></i>
          {{ state.numMembers }} {{ 'title.members' | translate }}
        </div>
        <div>
          <a class="button text-primary">
            <i class="ri-user-settings-line" *ngIf="!state.mobile"></i>
            {{
              (state.mobile ? 'core.members' : (canManageMembers ? 'button.manage_members' : 'button.view_members'))
                | translate }}
          </a>
        </div>
      </a>
    </nav>
  </div>
</ng-container>

<mat-tab-nav-panel #tabPanel>
  <router-outlet></router-outlet>
</mat-tab-nav-panel>
